export default __webpack_public_path__ + "static/media/groupImg.2859fdd6.svg";